/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PrincipalRolesControllerFindOneQueryResponse, PrincipalRolesControllerFindOnePathParams, PrincipalRolesControllerFindOneQueryParams, PrincipalRolesControllerFindOne400, PrincipalRolesControllerFindOne401, PrincipalRolesControllerFindOne403, PrincipalRolesControllerFindOne404 } from "../../models/principalRolesController/PrincipalRolesControllerFindOne";

function getPrincipalRolesControllerFindOneUrl(id: PrincipalRolesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/principal-roles/${id}` as const }  
  return res
}

/**
 * @summary Get a principal role assignment by id
 * {@link /api/v1/principal-roles/:id}
 */
export async function principalRolesControllerFindOne(id: PrincipalRolesControllerFindOnePathParams["id"], params?: PrincipalRolesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PrincipalRolesControllerFindOneQueryResponse, ResponseErrorConfig<PrincipalRolesControllerFindOne400 | PrincipalRolesControllerFindOne401 | PrincipalRolesControllerFindOne403 | PrincipalRolesControllerFindOne404>, unknown>({ method : "GET", url : getPrincipalRolesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}